import "./TypingLoader.css";

const TypingLoader = ({ fadeOut }) => {
  return (
    <div className={`typing-loader-overlay ${fadeOut ? "fade-out" : ""}`}>
      <div className="typing-box">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default TypingLoader;
